(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-grid"] && !Shopify.designMode) return;
  try {
    
$(".js-slick-grid").slick({
    autoplay: true, 
    autoplaySpeed: 0,
    speed: 7500,
    cssEase: "linear",
    arrows: false,
	dots: false,
    infinite: true,
    swipe: false,
    pauseOnFocus: false,
    pauseOnHover: false,
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-img"] && !Shopify.designMode) return;
  try {
    
$(".js-slick-img").slick({
    autoplay: true, 
    autoplaySpeed: 2000,
    speed: 2000,
    arrows: false,
	dots: false,
    infinite: true,
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',
  function() {
    const swiper = new Swiper('.swiper', {
    // // ページネーション
    // pagination: {
    //   el: '.swiper-pagination-card',
    //   clickable: true,
    // },
    // // 前後の矢印
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    // スライドのループ
    loop: true,
    effect: "slide",
    speed: 2000,
    autoplay: {
      delay: 2000,
      stopOnLastSlide: false,
		disableOnInteraction: false,
		reverseDirection: false
    },
  });

  }
);

document.addEventListener('DOMContentLoaded',
  function() {
    const slideWrapper = document.querySelectorAll('.slide-wrapper');
    slideWrapper.forEach(el => {
  
  if(el.clientWidth > document.body.clientWidth) {
    el.classList.add('swiper-wrapper');
    const children = el.children; //.slide-wrapperの子要素
    const parent = el.parentNode; //.slide-wrapperの親要素

    for (var i = 0, len = children.length; i < len; i++) {
      // 子要素全てにclassを付与
      children[i].classList.add("swiper-slide");
    };
      // 親要素全てにclassを付与
    parent.classList.add("swiper");
    
  }
  
});
  }
);

  } catch(e) { console.error(e); }
})();
})();
